import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import type { DokumentTyp } from "@/lib/dokumente";
import { useDocumentCreate } from "@/pages/dokumente/useDocumentCreate";

const TYPEN: DokumentTyp[] = ["angebot", "auftragsbestaetigung", "lieferschein", "rechnung"];

function parsePositiveInt(value: string | null): number | null {
  if (!value || !/^\d+$/.test(value)) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

/**
 * Deep-Link-Route `/dokumente/neu` – öffnet den globalen Erstellen-Dialog
 * und navigiert nach Schließen zurück zur Dokumentenübersicht.
 */
export function DocumentCreateRoute() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { open, close, isOpen } = useDocumentCreate();
  const openedRef = useRef(false);
  const sawOpenRef = useRef(false);

  useEffect(() => {
    if (openedRef.current) return;
    openedRef.current = true;

    const typParam = searchParams.get("typ") as DokumentTyp | null;
    open({
      auftragId: parsePositiveInt(searchParams.get("auftrag_id")),
      quellDokumentId: parsePositiveInt(searchParams.get("quell_dokument_id")),
      typ: typParam && TYPEN.includes(typParam) ? typParam : undefined,
      returnTo: "/dokumente",
    });
  }, [open, searchParams]);

  useEffect(() => {
    if (isOpen) {
      sawOpenRef.current = true;
      return;
    }
    if (!sawOpenRef.current) return;
    navigate("/dokumente", { replace: true });
  }, [isOpen, navigate]);

  useEffect(() => {
    return () => {
      if (openedRef.current) close();
    };
  }, [close]);

  return null;
}
